import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();


$('[data-reveal]').on('open.zf.reveal', function() {

	$('.orbit [data-src]').each(function(){
      	let $this = $(this),
	  	src = $(this).data('src');
      	$this.attr('src', src);
    });

	$('.orbit').foundation('_reset');
	$(window).trigger('resize');
    Foundation.reInit($(".orbit"));
});

let interval;
let interval_on = false;
let interval_image_id;

$("body").on("mouseenter", ".non-touch img", function () {
	let image = $(this);
	roll(image);
	removeAnimateArrow();

}).on("mouseleave", ".non-touch img", function () {
	clearInterval(interval);
	interval_on = false;
});

$(".we-are .animate").click(function () {
	let image = $(this).parent().parent().find("img");
	roll(image);
	removeAnimateArrow();
});

$(".we-are img").click(function () {
	let image = $(this);
	roll(image);
});

function removeAnimateArrow() {
	$(".we-are .animate").animate(
		{ opacity: 0 },
		400,
		function() {
			$(".we-are .animate").removeClass("animate");
		}
	);
}

function roll(image) {
	let imageId = image.attr("id");

	if (interval_on === true) {
		interval_on = false;
		clearInterval(interval);

		if(imageId !== interval_image_id) {
			interval = setInterval(function() {
				rollImages(imageId);
				interval_on = true;
			}, 100)
		}

	} else {
		interval = setInterval(function() {
			rollImages(imageId);
			interval_on = true;
		}, 100)
	}

	interval_image_id = imageId
}

function rollImages(imageId) {
	let image = $("#" + imageId);
	let current_image = image.data("id");
	let path = image.data("path");

	let new_image = current_image + 1;
	let new_path = path + new_image.toString() + ".jpg";

	if(new_image > 23) { new_image = 1; }

	image.attr("src", new_path);
	image.data("id", new_image);
}

$(document).ready(function() {
	let hostname = $(location).attr('hostname');

	if (hostname.match("^de")) {
		$("a.de").addClass("is-active");
	} else if (hostname.match("^en")) {
		$("a.en").addClass("is-active");
	} else {
		$("a.hr").addClass("is-active");
	}

	let touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
	if (!touchsupport){ // browser supports touch
		$(".we-are").addClass("non-touch");
	}
});

$(window).on('load', function () {
	let i;
	for (i = 2; i < 25; i++) {
		let image1 = $("#v1");
		let path1 = image1.data("path");

		let new_path_1 = path1 + i.toString() + ".jpg";
		image1.append("<img src=" + new_path_1 + " />");

		let image2 = $("#v2");
		let path2 = image2.data("path");

		let new_path_2 = path2 + i.toString() + ".jpg";
		image2.append("<img src=" + new_path_2 + " />");

		let image3 = $("#v3");
		let path3 = image3.data("path");

		let new_path_3 = path3 + i.toString() + ".jpg";
		image3.append("<img src=" + new_path_3 + " />");
	}

	let cookie = getCookie("GDPRConsent");
	if(cookie) {
		console.log(cookie)
	} else {
		$("#gdpr-message").show();
	}
});

$("#gdpr-message a.button").click(function () {
	setCookie();

	return false;
});

function getCookie(name) {
    let match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)')); return match ? match[1] : null;
}

function setCookie(){
	let d = new Date();
	let year = d.getFullYear();
	let month = d.getMonth();
	let day = d.getDate();
	let date = new Date(year + 2, month, day);
	let dateString = date.toGMTString();
    document.cookie = "GDPRConsent=true; expires=" + dateString;
    $("#gdpr-message").hide();
}